<template>
  <div class="between" v-loading.fullscreen.lock="loading">
    <apply-step ref="applyStepRef" />

    <!-- 确认套餐 -->
    <confirm-package />

    <!-- 申请步骤回显 -->
    <application-steps-echo ref="applicationStepsEchoRef" />

    <!-- 电子发票信息 -->
    <electronic-invoiceInfo ref="electronicInvoiceInfoRef"></electronic-invoiceInfo>

    <!-- 相关申请选择(二选一)、协议签署 -->
    <declare-and-protocol ref="declareAndProtocolRef"></declare-and-protocol>

    <!-- 保存 -->
    <div class="pt60 pb20 fxRow" v-if="initOk">
      <el-button type="primary" :disabled="saveLoading || submitLoading" @click="lastStep" class="pl20 pr20 fz16 mr4">{{ $t("common.button.last") }}</el-button>
      <el-button :loading="saveLoading" :disabled="submitLoading" class="pl20 pr20 fz16 mr4" @click="onSave">
        {{ $t("common.button.save") }}
      </el-button>
      <el-button :loading="submitLoading" :disabled="saveLoading" type="primary" class="pl20 pr20 fz16" @click="onSubmit">
        {{ $t("common.button.submit") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import ApplyStep from "@/components/ApplyStep";
import ConfirmPackage from "../components/ConfirmPackage";
import ApplicationStepsEcho from "../components/ApplicationStepsEcho";
import ElectronicInvoiceInfo from "../components/ElectronicInvoiceInfo";
import DeclareAndProtocol from "../components/DeclareAndProtocol";
import pageGuardMixin from "@/mixins/pageGuardMixin";
import { mapState, mapActions } from "vuex";
export default {
  name: "EnrollAffirm",
  mixins: [pageGuardMixin],
  components: {
    ApplyStep,
    ConfirmPackage,
    ApplicationStepsEcho,
    ElectronicInvoiceInfo,
    DeclareAndProtocol,
  },
  data() {
    return {
      initOk: false, // 初始化是否完成
      loading: false,
      applyId: null,
      saveLoading: false,
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail", "applymentHasNomineeDirector", "applymentHasEPApplication"]),
  },
  methods: {
    ...mapActions("applyment", ["fetchApplymentDetail", "saveApplyment", "commitApplyment"]),
    // 跳转提示
    toLinkTipe() {
      this.$message({
        message: this.$t("common.success.submit"),
        type: "success",
        duration: 1000,
        onClose: () => {
          this.$router.push({
            path: "/enroll/notPaid",
            query: {
              applymentId: this.applyId,
            },
          });
        },
      });
    },
    // 保存接口 - http
    saveHttp() {
      return new Promise((resolve, reject) => {
        this.saveRequestState = 1;

        const params01 = this.$refs.electronicInvoiceInfoRef.getParamsData();
        const params02 = this.$refs.declareAndProtocolRef.getParamsData();
        const currentStepIndex = this.$refs.applyStepRef.getCurrentStepIndex();

        this.saveApplyment({
          ...params01,
          ...params02,
          lastStayPage: currentStepIndex,
        })
          .then(res => {
            this.saveRequestState = 2;
            resolve(res);
          })
          .catch(err => {
            this.saveRequestState = 3;
            reject(err);
          });
      });
    },
    // 上一步
    lastStep() {
      this.$refs.applyStepRef.toPreviousStep();
    },
    // 保存
    async onSave() {
      try {
        this.saveLoading = true;
        await this.saveHttp();
        this.$message.success(this.$t("common.success.save"));
      } catch (error) {
        console.error(error);
      } finally {
        this.saveLoading = false;
      }
    },
    // 提交 - 按钮
    async onSubmit() {
      try {
        // 检查电子发票信息必填项
        await this.$refs.electronicInvoiceInfoRef.dataFormSubmit();
        // 检查声明和协议必填项
        await this.$refs.declareAndProtocolRef.dataFormSubmit();
        // 确认保存对话框
        await this.$confirm(this.$t("common.hint.submitOrder"), this.$t("common.hint.title"), {
          type: "warning",
        });
        this.submitLoading = true;
        // 保存
        await this.saveHttp();
        // 提交
        await this.commitApplyment();
        // 跳转页面
        this.toLinkTipe();
      } catch (error) {
        console.error(error);
        this.submitLoading = false;
      }
    },
    // 页面初始化数据整理
    pageInit() {
      this.loading = true;
      this.fetchApplymentDetail(this.applyId).then(data => {
        // 检查当前页面的申请步骤是否存在(pageGuardMixin中的方法)
        this.checkCurrentPageHasApplyStep();
        // 检查当前页面的申请状态能否进入该页面(pageGuardMixin中的方法)
        this.checkCurrentPageSupportApplymentStatus();

        this.$nextTick(() => {
          // 初始化申请步骤回显
          this.$refs.applicationStepsEchoRef.init();
          // 初始化电子发票信息
          this.$refs.electronicInvoiceInfoRef?.init();
          // 初始化声明和协议
          this.$refs.declareAndProtocolRef.init();

          setTimeout(() => {
            this.loading = false;
            this.initOk = true;
          });
        });
      }).catch(() => {
        this.loading = false;
      });
    },
  },
  created() {
    // 检查url是否携带参数id (pageGuardMixin中的方法)
    this.checkPathQueryHasId();
    // 检查url是否存在参数(id)
    const query = this.$route.query;
    if (query.id) {
      this.applyId = query.id;
      this.pageInit();
    }
  },
};
</script>

<style lang="scss" scoped></style>
